// This file ensures necessary polyfills are available
import { Buffer } from 'buffer';
import process from 'process';

// Ethereum provider polyfill
if (typeof window.ethereum === 'undefined') {
  console.log('MetaMask is not installed - adding empty ethereum object');
  window.ethereum = null;
}

// Make Buffer available globally
window.Buffer = window.Buffer || Buffer;

// Make process available globally
window.process = window.process || process;